module.exports = __webpack_public_path__ + "static/img/kh-0.56dadc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-0.png
// module id = fExq
// module chunks = 5